import type Message from "owa-service/lib/contract/Message";

const isMessageUnauthenticated = (message: Message): boolean | undefined => message.AntispamUnauthenticatedSender;

export default isMessageUnauthenticated;
